module.exports = __webpack_public_path__ + "static/media/DRREDDY.3be975d0.txt";